import { endOfDay, startOfDay, subDays } from "date-fns";
import type { DateRange } from "@/hooks/useDateRange";

export function createDefaultRoomUsageDateRange(): DateRange {
  const now = new Date();

  return {
    from: subDays(now, 89),
    to: now,
  };
}

export function toRoomUsageApiRange(dateRange: DateRange) {
  const from = dateRange.from ? startOfDay(dateRange.from).toISOString() : "";
  const to = dateRange.to ? endOfDay(dateRange.to).toISOString() : "";

  return { from, to };
}

export function formatOccupancyRate(rate: number): string {
  return `${Math.round(rate * 100)}%`;
}
